import mutations from './mutations';
import Cookies from 'js-cookie';
import axios from 'axios';
import { notification } from 'ant-design-vue';
import { endpoints } from '@/services/api';

const errorNotification = str => {
  notification.error({
    message: str,
  });
};

const state = () => ({
  login: Cookies.get('logedIn'),
  jwt_token: Cookies.get('token'),
  is_root: Cookies.get(new Buffer.from('apps_is_root', 'binary').toString('base64')),
  loading: false,
  error: null,
  qrCode: null,
  email: null,
  two_fa_verify: false,
  user_name: Cookies.get('tsoft_apps_user_name'),
  user_surname: Cookies.get('tsoft_apps_user_surname'),
  user_company: Cookies.get('tsoft_apps_user_company'),
});

const getters = {
  _qrCode: state => state.qrCode,
  _email: state => state.email,
  _two_fa_verify: state => state.two_fa_verify,
};

const actions = {
  async login({ commit }, authData) {
    commit('loginBegin');
    commit('setState', { key: 'two_fa_verify', value: false });
    return axios
      .post(process.env.VUE_APP_API_ENDPOINT + endpoints.auth_login, authData)
      .then(response => {
        if (response.data.status === true) {
          var resp = response.data.data;
          commit('setUserName', resp.name);
          commit('setUserSurname', resp.surname);
          commit('setUserCompany', resp.company);
          Cookies.set('tsoft_apps_user_name', resp.name);
          Cookies.set('tsoft_apps_user_surname', resp.surname);
          Cookies.set('tsoft_apps_user_company', resp.company);
          localStorage.setItem('i_lang', resp.language);
          commit('i18n/setLang', resp.language);
          if (resp.two_fa_verify == true) {
            commit('setState', { key: 'two_fa_verify', value: true });
            commit('setState', { key: 'email', value: authData.email });
            if (typeof resp.google_qr != undefined) {
              commit('setState', { key: 'qrCode', value: resp.google_qr });
            }
          } else {
            Cookies.set('logedIn', true);
            Cookies.set('token', resp.token);
            Cookies.set(new Buffer.from('apps_is_root', 'binary').toString('base64'), resp.type);
            commit('setRoot', resp.type);
            commit('loginSuccess', true);
            commit('setJwtToken', resp.token);
          }
        } else {
          errorNotification(response.data.message);
          commit('loginErr', response.data.message);
        }
      })
      .catch(e => {
        commit('loginErr', e);
      });
  },
  async register({ commit }, registerData) {
    commit('loginBegin');
    return axios
      .post(process.env.VUE_APP_API_ENDPOINT + endpoints.auth_register, registerData)
      .then(response => {
        if (response.data.status === true) {
          Cookies.set('token', response.data.data.token);
          Cookies.set('logedIn', true);
          commit('loginSuccess', true);
        } else {
          errorNotification(response.data.message);
          commit('loginErr', response.data.message);
        }
      })
      .catch(e => {
        commit('loginErr', e);
      });
  },
  async logOut({ commit }) {
    try {
      commit('logoutBegin');
      Cookies.remove('logedIn');
      Cookies.remove('token');
      Cookies.remove('tsoft_apps_user_name');
      Cookies.remove('tsoft_apps_user_surname');
      Cookies.remove(new Buffer.from('apps_is_root', 'binary').toString('base64'));
      commit('logoutSuccess', null);
    } catch (err) {
      commit('logoutErr', err);
    }
  },
};

export default {
  namespaced: false,
  state,
  actions,
  mutations,
  getters,
};
